export function Dropdown(element) {
	let isExpanded = false;

	let expandedClass = 'is-expanded';
	let collapsedClass = 'is-collapsed';

	let targetId = element.dataset.target;
	let targetElement = document.getElementById(targetId);

	if (!targetElement) {
		return;
	}

	function create() {
		collapse(true);

		element.addEventListener('click', toggle);
		element.addEventListener('keydown', handleKeydown);

		element.setAttribute('tabindex', 0);
		element.setAttribute('role', 'button');
		element.setAttribute('aria-expanded', 'false');
		element.setAttribute('aria-controls', targetId);
	}

	function destroy() {
		element.removeEventListener('click', toggle);
		element.removeEventListener('keydown', handleKeydown);

		element.removeAttribute('role');
		element.removeAttribute('tabindex');
		element.removeAttribute('aria-expanded');
		element.removeAttribute('aria-controls');
		element.classList.remove(expandedClass, collapsedClass);
		targetElement.classList.remove(expandedClass, collapsedClass);
	}

	function toggle() {
		isExpanded ? collapse() : expand();
	}

	function expand(force = false) {
		if (isExpanded && !force) {
			return;
		}

		element.setAttribute('aria-expanded', 'true');

		element.classList.add(expandedClass);
		element.classList.remove(collapsedClass);

		targetElement.classList.add(expandedClass);
		targetElement.classList.remove(collapsedClass);

		isExpanded = true;
	}

	function collapse(force = false) {
		if (!isExpanded && !force) {
			return;
		}

		element.setAttribute('aria-expanded', 'false');

		element.classList.add(collapsedClass);
		element.classList.remove(expandedClass);

		targetElement.classList.add(collapsedClass);
		targetElement.classList.remove(expandedClass);

		isExpanded = false;
	}

	function handleKeydown(event) {
		if (!(event.key === ' ' || event.key === 'Enter')) {
			return;
		}

		toggle();
		event.preventDefault();
	}

	return {
		create,
		destroy,
	};
}
